import React, { useState } from 'react';
import { useStyletron } from 'baseui';
import { ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import { Radio, RadioGroup } from 'baseui/radio';
import { HeadingSmall } from 'baseui/typography';
import { useReportQAContext } from '../../../context';
const ReportsModalContent = () => {
  const [css] = useStyletron();
  const [, mutate, query] = useReportQAContext();
  const {
    selectedProject
  } = query(state => state);
  const [value, setValue] = useState(null);
  return <>
      <ModalHeader>Report QA - Select a Report</ModalHeader>
      <ModalBody>
        <div className={css({
        maxHeight: '60vh'
      })}>
          <HeadingSmall>Reports</HeadingSmall>
          <RadioGroup name="Reports" onChange={e => setValue(e.currentTarget.value)} value={value}>
            {selectedProject.reports.map(report => {
            return <Radio value={`${report.id}`}>{report.filename}</Radio>;
          })}
          </RadioGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        {value ? <ModalButton onClick={() => {
        mutate(state => ({
          ...state,
          modal: {
            ...state.modal,
            content: 'config',
            selectedReportId: Number(value)
          }
        }));
      }}>
            Configure
          </ModalButton> : <ModalButton disabled>Configure</ModalButton>}
      </ModalFooter>
    </>;
};
export default ReportsModalContent;